import IconButton from '@material-ui/core/IconButton';
import { styled } from "@material-ui/core/styles";
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { tooltipClasses } from '@mui/material/Tooltip';
import clsx from 'clsx';
import styles from './styles.module.css';

const LightTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: '#A2A0A0',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#A2A0A0',
    color: '#fff',
    fontSize: 12,
    top: '-2px',
  },
}));
const IconButtonCustom = ({ title = 'Ok', icon, tooltipTitle, isDisabled, isHightLight, isMobile, ...rest }) => (
  <div className={styles.container}>
    <LightTooltip title={tooltipTitle} arrow placement="top">
      <span>
        <IconButton
          classes={{
            root: clsx(styles.root),
          }}
          {...rest}
          disabled={isDisabled}
          disableRipple={isDisabled}
          className={clsx(!isDisabled && styles?.default, isHightLight && styles.hightLight,isMobile && styles.mobile)}
        >
          {icon}
        </IconButton>
      </span>
    </LightTooltip>
    <Typography className={styles.typography}> {title}</Typography>
  </div>
);

export default IconButtonCustom;
